// import { LanguageService } from '../../../core/services/language/language.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
// import { TranslatePipe } from '@ngx-translate/core';
import { Component } from '@angular/core';

@Component({
	selector: 'app-login-error',
	imports: [
		ReactiveFormsModule, 
		// TranslatePipe,
		FormsModule
	],
	templateUrl: './login-error.component.html',
	styleUrl: './login-error.component.scss',
})

export class LoginErrorComponent {

	constructor(
		// private _languageService: LanguageService,
		private authSvc: AuthService,
	) {	}

	public login(): void {
		this.authSvc.logout();
	}

}